import ProtectedRoute from '@commons/layouts/ProtectedRoute'
import { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import publicRoutes from './routes/public'
import adminRoutes from './routes/admin'
import doctorRoutes from './routes/doctor'
import institutionRoutes from './routes/institution'
import patientRoutes from './routes/patient'
import PageNotFound from './pages/404'
import PaymentProcess from './pages/front/payments/process'
import PaymentSucess from './pages/front/payments/success'
import PaymentFailed from './pages/front/payments/process'
const PrivateLayout = lazy(() => import('@commons/layouts/private'))
const AdminLayout = lazy(() => import('@commons/layouts/private/admin'))
const PublicLayout = lazy(() => import('@commons/layouts/public'))

const App = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="payments">
            <Route Component={PaymentProcess} path="process" />
            <Route Component={PaymentSucess} path="success" />
            <Route Component={PaymentFailed} path="failed" />
          </Route>
          <Route path="/" element={<PublicLayout />}>
            <Route path="*" Component={PageNotFound} />
            {publicRoutes.map((item, i) => (
              <Route {...item} key={i} />
            ))}
          </Route>
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute
                allowedRoles={['admin']}
                Component={AdminLayout}
              />
            }
          >
            {adminRoutes.map((item, i) => (
              <Route {...item} key={i} />
            ))}
          </Route>
          <Route
            path="/patient/*"
            element={
              <ProtectedRoute
                allowedRoles={['patient']}
                Component={PrivateLayout}
              />
            }
          >
            {patientRoutes.map((item, i) => (
              <Route {...item} key={i} />
            ))}
          </Route>
          <Route
            path="/doctor/*"
            element={
              <ProtectedRoute
                allowedRoles={['doctor']}
                Component={PrivateLayout}
              />
            }
          >
            {doctorRoutes.map((item, i) => (
              <Route {...item} key={i} />
            ))}
          </Route>

          <Route
            path="/institution/*"
            element={
              <ProtectedRoute
                allowedRoles={['institution']}
                Component={PrivateLayout}
              />
            }
          >
            {institutionRoutes.map((item, i) => (
              <Route {...item} key={i} />
            ))}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
